import { Box, Breadcrumbs, Button, Link, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CentralTextField, Ico_FolderHeader, Ico_WorkItemOverViewHeader, useSnackbar, Ico_Clone } from "@sagecentral/core-ui";
import { useFeatureEnabled } from "hooks/shared";
import { useWorkItemFieldUpdater, useWorkItemPermissions } from "hooks/work-items";
import { IWorkItemHeaderInfo, IWorkItemOverview } from "models/work-items";
import React, { useState } from "react";
import { WorkItemsClone } from "../clone";

const FontStyleDef = {
    fontSize: '16px',
    lineHeight: '24px',
    color: 'black',
};

const TitleFontStyleDef = {
    fontSize: '16px',
    lineHeight: '24px',
    color: 'black',
    display: 'flex',
    marginTop: '8px'
};

const LinkStyle = styled(Link)({
    ...FontStyleDef,
    color: '#0066CC'
});

const ParentFontStyleDef = {
    ...FontStyleDef,
    display: "flex",
    width: '90%',
    alignItems: 'center',
};

type WorkItemHeaderProps = {
    workItem: IWorkItemOverview | null;
};

const WorkItemHeader = (props: WorkItemHeaderProps) => {
    const { workItem } = props;
    const { displaySnackbar } = useSnackbar();
    const permissions = useWorkItemPermissions();
    const [wave4Enabled] = useFeatureEnabled('wave-4');
    const [openCloneWorkitem, setOpenCloneWorkitem] = useState(false);

    const workitemEditUrl = wave4Enabled
        ? process.env.REACT_APP_PUBLIC_URL + `/workitems/${workItem?.id}/overview`
        : process.env.REACT_APP_CLASSIC_URL + `/workitemenduser/editworkitem?workitemId=${workItem?.id}`;
    const getProjectUrl = (projectId: string) => process.env.REACT_APP_PUBLIC_URL + `/projects/all/${projectId}`;

    const [setName, nameWorking] = useWorkItemFieldUpdater('name', {
        onUpdate: () => displaySnackbar('success', 'Name has been updated')
    });

    return (
        <Box>
            <Box
                sx={{
                    marginLeft: '48px',
                    display: 'flex',
                    alignContent: 'center',
                    marginTop: '16px',
                    alignItems: 'flex-start'
                }}>
                <Breadcrumbs
                    separator='>'
                    sx={{
                        display: "inline-block",
                        width: '100%',
                        '& li': {
                            width: '100%'
                        }
                    }}
                >
                    <Typography sx={TitleFontStyleDef}>
                        <Box sx={{ display: 'flex', minWidth: '80%' }}>
                            <Box sx={{ marginRight: '5px' }}>{Ico_WorkItemOverViewHeader}</Box>
                            <span style={{ minWidth: '90px' }}>Work Item:&nbsp;</span>
                            <span style={{ fontWeight: 'bold', minWidth: '70%' }}>
                                <Box sx={{ display: 'flex' }}>
                                    <CentralTextField
                                        value={workItem?.name}
                                        applyValue={setName}
                                        working={nameWorking}
                                        fullWidth={true}
                                    />
                                    <span>({workItem?.id})</span>
                                </Box>
                            </span>
                        </Box>
                    </Typography>
                </Breadcrumbs>
                {permissions?.canCloneWorkItem && workItem?.canBeCloned &&
                    <>
                        <Button sx={{ ml: '24px' }} onClick={() => setOpenCloneWorkitem(!openCloneWorkitem)}> {<Ico_Clone sx={{ fill: "#001A69" }} />}&nbsp;&nbsp;Clone</Button>
                        <WorkItemsClone workItemId={workItem?.id!} workItemName={workItem?.name!} openCloneWorkitem={openCloneWorkitem} setOpenCloneWorkitem={setOpenCloneWorkitem} />
                    </>
                }
            </Box>
            {workItem != null && (workItem.isProject || (workItem.parents && workItem.parents.length > 0 && workItem.parents.some(x => x.id > 0))) ?
                <Box
                    sx={{
                        marginLeft: '88px',
                        display: 'flex',
                        alignContent: 'center',
                        marginTop: '16px'
                    }}>
                    <Typography sx={ParentFontStyleDef}>
                        <Box sx={{ marginRight: '5px' }}>{Ico_FolderHeader}</Box>
                        Related Project:&nbsp;
                        {workItem.isProject &&
                            <>
                                <LinkStyle href={getProjectUrl(workItem.id.toString())}>
                                    {workItem.name}
                                </LinkStyle>
                                <>{(workItem.parents && workItem.parents.length > 0 && workItem.parents.some(x => x.id > 0)) && ', '}</></>
                        }
                        {
                            (workItem.parents && workItem.parents.length > 0 && workItem.parents.some(x => x.id > 0)) &&
                            <>
                                {
                                    workItem.parents.map((parent, index) => (
                                        <React.Fragment key={index}>
                                            {parent.id > 0 && <>
                                                <LinkStyle sx={{ fontWeight: 'bold' }} href={getProjectUrl(parent.id.toString())}>
                                                    {parent.name}
                                                </LinkStyle>
                                                {index !== workItem.parents!.length - 1 && ', '}
                                            </>}
                                        </React.Fragment>
                                    ))
                                }
                            </>}
                    </Typography>
                </Box>


                : null}
        </Box>
    );
};

export default WorkItemHeader;